module.exports = __webpack_public_path__ + "img/draw.481ad6d2.png";